module.exports = __webpack_public_path__ + "img/slika2_2022.65227afa.png";